import { useRef } from 'react';

type ColorPickerTriggerProps = {
  color: string;
  onChange: (value: string) => void;
  style?: React.CSSProperties;
};

export const ColorPickerTrigger = ({ color, onChange, style = {} }: ColorPickerTriggerProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleOpenPicker = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation();
    inputRef.current?.click();
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block', ...style }}>
      <button
        onClick={handleOpenPicker}
        style={{
          width: '2rem',
          height: '2rem',
          backgroundColor: color.includes('#') ? color : `#${color}`,
          border: '1px solid #ccc',
          borderRadius: '0.4rem',
          cursor: 'pointer',
          padding: 0,
        }}
      />
      <input
        ref={inputRef}
        type="color"
        value={color}
        onChange={(e) => onChange(e.target.value)}
        style={{
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'none',
          width: 0,
          height: 0,
        }}
      />
    </div>
  );
};
